export default __webpack_public_path__ + "static/media/indiaCovid19Chi.0bad40ef.jpg";